// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigWinchStandOptionLink } from './part-config-winch-stand-option-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigWinchStand extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  _options: any[] = [];

  get optionsHtml(): string {
      return this._options.map((x) => `${x.name}${x.isDefault ? ' ★' : ''}`).join('<br/>');
  }
  setOptionLinks(links: PartConfigWinchStandOptionLink[]) {
      this._options = links
          .filter((x) => !x.deleted)
          .map((x) => ({ id: x.id, optionId: x.partConfigWinchStandOption.id, name: `${x.partConfigWinchStandOption.name}${x.isDefault ? ' (Default)' : ''}`, isDefault: x.isDefault }));
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  value?: string;
  partConfigWinchStandOptionLinks!: PartConfigWinchStandOptionLink[];
}

